"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DepositStatusComponent = function DepositStatusComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var txnState = props.txnState;
  var status = {
    '1': {
      status: 'pending',
      firstLine: t("Your deposit is being processed."),
      secondLine: t("Your account balance will be updated soon.")
    },
    '2': {
      status: 'successful',
      firstLine: t("Your deposit was successfull."),
      secondLine: t("Your account balance will be updated soon.")
    },
    '3': {
      status: 'failed',
      firstLine: t("There was a problem with your deposit."),
      secondLine: t("Please try again or contact an administrator.")
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, status[txnState].firstLine), /*#__PURE__*/_react["default"].createElement("div", null, status[txnState].secondLine));
};
DepositStatusComponent.propTypes = {
  txnState: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = DepositStatusComponent;